import React, { useState, useEffect } from 'react';
import logo from 'asset/img/download-logo.webp';
import './index.scss';
import background from 'asset/img/background1.webp';
import bk0 from 'asset/img/download0.webp';
import bk1 from 'asset/img/download1.webp';
import bk2 from 'asset/img/download2.webp';
import bk3 from 'asset/img/download3.webp';
import Android from 'asset/fonts/wukong-release.apk';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

// 检测是否在微信浏览器中
const isWechat = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
};

const Download = () => {
    const [showWechatTip, setShowWechatTip] = useState(false);
    
    useEffect(() => {
        // 检测微信浏览器
        if (isWechat()) {
            setShowWechatTip(true);
        }
    }, []);

    const tabItem = [
        { grade: '4.9', name: '用户评分', highlight: true },
        { grade: '3万+', name: '累计下载' },
        { grade: '4MB', name: '安装包' },
        { grade: '100%', name: '安全认证' },
    ]

    const features = [
        '解放家长', '右脑学习', '听力为王'
    ];

    const bklist = [bk0, bk1, bk2, bk3]

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = Android;
        link.download = '悟空听说.apk';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className='download-container'>
            {/* 微信浏览器提示 */}
            {showWechatTip && (
                <div className='wechat-tip-overlay' onClick={() => setShowWechatTip(false)}>
                    <div className='wechat-tip-arrow'></div>
                    <div className='wechat-tip-content'>
                        <div className='wechat-tip-title'>请在浏览器中下载</div>
                        <div className='wechat-tip-text'>
                            点击右上角 <span>···</span>
                        </div>
                        <div className='wechat-tip-text'>
                            选择 <span>在浏览器中打开</span>
                        </div>
                        <div className='wechat-tip-hint'>点击任意位置关闭</div>
                    </div>
                </div>
            )}
            
            <div className='download-bk'>
                <img src={background} alt="background" />
            </div>
            
            <div className='download-content'>
                {/* 顶部标题卡片 */}
                <div className='download-title'>
                    <div className='logo'>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className='title-info'>
                        <div className='title'>悟空听说</div>
                        <div className='subtitle'>让小朋友爱上英语学习</div>
                        <div className='version'>v2.0.1 官方正版</div>
                    </div>
                </div>

                {/* 数据展示 */}
                <div className='download-des'>
                    {tabItem.map((item, index) => (
                        <div key={index} className='item'>
                            <div className={`item-grade ${item.highlight ? 'highlight' : ''}`}>
                                {item.grade}
                            </div>
                            <div className='item-name'>{item.name}</div>
                        </div>
                    ))}
                </div>

                {/* 特色介绍 */}
                <div className='download-features'>
                    <div className='feature-title'>产品亮点</div>
                    <div className='feature-list'>
                        {features.map((feature, index) => (
                            <span key={index} className='feature-tag'>{feature}</span>
                        ))}
                    </div>
                </div>

                {/* 截图轮播 */}
                <div className='download-tab'>
                    <div className='section-title'>精彩截图</div>
                    <Swiper
                        slidesPerView={2.2}
                        spaceBetween={15}
                        centeredSlides={false}
                        allowTouchMove={true}
                        resistance={true}
                        resistanceRatio={0.85}
                        followFinger={true}
                        speed={300}
                        simulateTouch={true}
                        preventClicks={true}
                        preventInteractionOnTransition={true}
                        navigation={false}
                        pagination={false}
                        scrollbar={false}
                    >
                        {bklist.map((item, index) => (
                            <SwiperSlide key={index}>
                                <div className="slide">
                                    <img src={item} alt={`screenshot-${index}`} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                {/* 下载按钮 */}
                <div className='download-btn'>
                    <div className='btn' onClick={handleDownload}>
                        <span className='btn-icon'>⬇</span>
                        立即下载
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Download;
